import { BrowserRouter, Route, Routes, StaticRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Hero from './pages/Hero';
import MainContent from './pages/MainContent';
import AdminLogin from './pages/AdminLogin';
import Admin from './pages/Admin';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';
import ThankYou from './pages/ThankYou';
import Form from './pages/Form';
import NotFound from './pages/NotFound';
import { RouteSeo } from './lib/seo';

interface AppProps {
  location?: string;
}

function App({ location }: AppProps) {
  const content = (
    <>
      <RouteSeo />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/main" element={<MainContent />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/form" element={<Form />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Analytics />
    </>
  );

  return (
    location ? <StaticRouter location={location}>{content}</StaticRouter> : <BrowserRouter>{content}</BrowserRouter>
  );
}

export default App;
